var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "fieldset",
    {
      staticClass: "my-3",
      attrs: {
        "aria-describedby": `upload-form-hint-${_vm.uniqueId} upload-form-deadline-${_vm.uniqueId} upload-form-info-${_vm.uniqueId} upload-form-error-${_vm.uniqueId}`,
      },
    },
    [
      _c(
        "div",
        { staticClass: "my-3 d-flex flex-column" },
        [
          _c("legend", { staticClass: "mr-3 mb-3" }, [
            _c(
              "h3",
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.context.attributes.customLabel) +
                    "\n                "
                ),
                _vm.context.attributes.required
                  ? [
                      _c(
                        "span",
                        {
                          staticClass: "text-primary-2",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v("*")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "sr-only" }, [
                        _vm._v(
                          "\n                        Dieses Feld wird benötigt um den Vorgang absenden zu können.\n                    "
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _vm.context.attributes.deadlineText
            ? _c(
                "div",
                {
                  staticClass: "upload-form-deadline mb-3",
                  attrs: { id: `upload-form-deadline-${_vm.uniqueId}` },
                },
                [
                  _c("i", { staticClass: "far fa-calendar-alt" }),
                  _vm._v(
                    "\n            einzureichen: " +
                      _vm._s(_vm.context.attributes.deadlineText) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.context.attributes.customHelp
            ? _c(
                "div",
                {
                  staticClass: "upload-form-hint mb-1",
                  attrs: { id: `upload-form-hint-${_vm.uniqueId}` },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.context.attributes.customHelp) +
                      "\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.currentView === "uploadView" && !_vm.canAddMoreFiles
            ? _c(
                "p",
                {
                  staticClass: "aletr alert-info",
                  attrs: {
                    id: `upload-form-info-${_vm.uniqueId}`,
                    role: "alert",
                  },
                },
                [
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v("Information:"),
                  ]),
                  _vm._v(
                    "Entferne zuerst eine Datei um Neue Dateien hochladen.\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.validationError
            ? _c(
                "p",
                {
                  staticClass: "aletr alert-info",
                  attrs: {
                    id: `upload-form-error-${_vm.uniqueId}`,
                    role: "alert",
                  },
                },
                [
                  _c("span", { staticClass: "sr-only" }, [_vm._v("Fehler:")]),
                  _vm._v(
                    " Alle Pflichtfeld müssen ausgefüllt werden.\n        "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("UploadedFileList", {
            attrs: { "uploaded-files": _vm.uploadedFiles },
          }),
          _vm._v(" "),
          _vm.currentView !== "uploadView" && _vm.canAddMoreFiles
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center ml-auto",
                },
                [
                  _c("div", { staticClass: "attachment-actions d-flex" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { "data-cy": "show-process-form" },
                        on: {
                          click: function ($event) {
                            _vm.currentView = "uploadView"
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Neue Datei hochladen\n                "
                        ),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.currentView === "uploadView" && _vm.canAddMoreFiles
        ? _c("div", [
            _vm.context.attributes.fileTypeUserDefined
              ? _c("div", { attrs: { "data-cy-field": "filetype" } }, [
                  _c(
                    "label",
                    {
                      staticClass: "text-title",
                      attrs: {
                        for: `upload-${_vm.context.attributes.processId}-file-type`,
                      },
                    },
                    [_vm._v("Dokumenttyp")]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "text-primary-2",
                      attrs: {
                        "aria-hidden": "true",
                        title:
                          "Dieses Feld wird benötigt um den Vorgang absenden zu können.",
                      },
                    },
                    [_vm._v("*")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "sr-only" }, [
                    _vm._v(
                      "Dieses Feld wird benötigt um den Vorgang absenden zu können."
                    ),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.fileType,
                        expression: "fileType",
                      },
                    ],
                    class: [
                      "form-control my-2 h-auto",
                      { "is-invalid": _vm.isEmptyFileType },
                    ],
                    attrs: {
                      id: `upload-${_vm.context.attributes.processId}-file-type`,
                      placeholder: "z.B. Nachweis",
                      autocomplete: "no",
                      type: "text",
                      required: "",
                    },
                    domProps: { value: _vm.fileType },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.fileType = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isEmptyFileType,
                          expression: "isEmptyFileType",
                        },
                      ],
                      staticClass: "invalid-feedback",
                    },
                    [
                      _vm._v(
                        "\n                Dokumenttyp ist ein Pflichtfeld.\n            "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { attrs: { "data-cy-field": "file" } }, [
              _c(
                "label",
                {
                  staticClass: "text-title",
                  attrs: { for: `upload-${_vm.context.attributes.processId}` },
                },
                [_vm._v("Datei hochladen")]
              ),
              _vm._v(" "),
              _c("input", {
                ref: "stina_file_upload",
                class: [
                  "form-control my-2 h-auto",
                  { "is-invalid": _vm.isEmptyFileRecord },
                ],
                attrs: {
                  name: _vm.context.attributes.name + "-file-upload",
                  accept: _vm.context.attributes.allowedMimeTypes,
                  type: "file",
                  required: "",
                },
                on: { change: _vm.addFile, input: _vm.addFile },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEmptyFileRecord,
                      expression: "isEmptyFileRecord",
                    },
                  ],
                  staticClass: "invalid-feedback",
                },
                [
                  _vm._v(
                    "\n                Datei ist ein Pflichtfeld.\n            "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.context.attributes.allowsUserDefinedComment
              ? _c(
                  "div",
                  { attrs: { "data-cy-field": "comment" } },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "text-title",
                        attrs: {
                          for: `upload-${_vm.context.attributes.processId}-comment`,
                        },
                      },
                      [_vm._v("Bemerkung")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "text-primary-2",
                        attrs: {
                          "aria-hidden": "true",
                          title:
                            "Dieses Feld wird benötigt um den Vorgang absenden zu können.",
                        },
                      },
                      [_vm._v("*")]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v(
                        "Dieses Feld wird benötigt um den Vorgang absenden zu können."
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.comment,
                          expression: "comment",
                        },
                      ],
                      class: [
                        "form-control my-2 h-auto",
                        { "is-invalid": _vm.isEmptyComment },
                      ],
                      attrs: {
                        id: `upload-${_vm.context.attributes.processId}-comment`,
                        autocomplete: "no",
                        type: "text",
                        required: "",
                      },
                      domProps: { value: _vm.comment },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.comment = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isEmptyComment,
                            expression: "isEmptyComment",
                          },
                        ],
                        staticClass: "invalid-feedback",
                      },
                      [
                        _vm._v(
                          "\n                Bemerkung ist ein Pflichtfeld.\n            "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.context.attributes.commentLabel
                      ? [
                          _c("p", [
                            _vm._v(
                              "\n                    Hinweis: " +
                                _vm._s(_vm.context.attributes.commentLabel) +
                                "\n                "
                            ),
                          ]),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "text-right" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-link",
                  on: {
                    click: function ($event) {
                      _vm.currentView = "infoView"
                    },
                  },
                },
                [_vm._v("\n                Abbrechen\n            ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { "data-cy-field": "upload-btn" },
                  on: { click: _vm.uploadFile },
                },
                [_vm._v("\n                Datei hochladen\n            ")]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }